export const categories = [
  {
    id: 1,
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20sneakers%20arranged%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20window%20light%20elegant%20minimalist%20product%20photography%20showcasing%20fashion%20footwear%20with%20warm%20cream%20tones%20editorial%20style%20lifestyle%20aesthetic&width=400&height=400&seq=cat-img-shoes-01&orientation=squarish',
    description: 'Premium footwear collection including sneakers, boots, and casual shoes for every occasion.',
  },
  {
    id: 2,
    name: 'Hoodies & Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20stylish%20hoodie%20neatly%20folded%20on%20light%20wooden%20surface%20with%20soft%20natural%20daylight%20streaming%20in%20warm%20beige%20neutral%20tones%20minimalist%20fashion%20product%20photography%20clean%20aesthetic%20editorial%20lifestyle%20shot&width=400&height=400&seq=cat-img-hoodies-02&orientation=squarish',
    description: 'Cozy hoodies and sweaters crafted for comfort and street-style fashion.',
  },
  {
    id: 3,
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20quality%20cotton%20tshirt%20elegantly%20displayed%20on%20light%20marble%20surface%20with%20soft%20shadows%20natural%20sunlight%20minimalist%20fashion%20photography%20warm%20cream%20tones%20clean%20editorial%20style%20product%20showcase&width=400&height=400&seq=cat-img-tshirts-03&orientation=squarish',
    description: 'Essential tees with premium fabrics, modern cuts, and versatile designs.',
  },
  {
    id: 4,
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20jacket%20displayed%20on%20wooden%20hanger%20against%20light%20neutral%20background%20with%20soft%20natural%20window%20lighting%20minimalist%20fashion%20photography%20editorial%20product%20showcase%20warm%20beige%20tones%20clean%20sophisticated%20aesthetic&width=400&height=400&seq=cat-img-jackets-04&orientation=squarish',
    description: 'Stylish outerwear from lightweight windbreakers to insulated winter jackets.',
  },
  {
    id: 5,
    name: 'Pants & Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-palette-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20casual%20pants%20neatly%20laid%20flat%20on%20clean%20white%20surface%20with%20soft%20natural%20daylight%20minimalist%20fashion%20product%20photography%20featuring%20modern%20trousers%20warm%20cream%20tones%20editorial%20lifestyle%20aesthetic&width=400&height=400&seq=cat-img-pants-05&orientation=squarish',
    description: 'Trendy bottoms including jeans, cargo pants, chinos, and summer shorts.',
  },
  {
    id: 6,
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-emotion-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20and%20beanie%20arranged%20on%20light%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20fashion%20accessory%20photography%20warm%20neutral%20tones%20clean%20editorial%20composition%20sophisticated%20product%20showcase&width=400&height=400&seq=cat-img-headwear-06&orientation=squarish',
    description: 'Caps, beanies, bucket hats and more to complete your look.',
  },
  {
    id: 7,
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20fashion%20outfit%20set%20elegantly%20displayed%20on%20clean%20light%20surface%20with%20soft%20natural%20window%20light%20minimalist%20product%20photography%20showcasing%20complete%20ensemble%20warm%20cream%20tones%20editorial%20aesthetic&width=400&height=400&seq=cat-img-sets-07&orientation=squarish',
    description: 'Coordinated outfit sets that take the guesswork out of styling.',
  },
  {
    id: 8,
    name: 'Underwear & Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20quality%20cotton%20undergarments%20neatly%20folded%20on%20clean%20white%20surface%20with%20soft%20diffused%20natural%20lighting%20minimalist%20product%20photography%20warm%20cream%20tones%20elegant%20clean%20editorial%20composition&width=400&height=400&seq=cat-img-underwear-08&orientation=squarish',
    description: 'Comfortable essentials designed with quality materials for everyday wear.',
  },
  {
    id: 9,
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20athletic%20sports%20jersey%20displayed%20on%20clean%20light%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20sportswear%20product%20photography%20warm%20neutral%20tones%20editorial%20composition%20showcasing%20modern%20design&width=400&height=400&seq=cat-img-jersey-09&orientation=squarish',
    description: 'Sports jerseys and athletic wear for fans and active lifestyles.',
  },
  {
    id: 10,
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20including%20sunglasses%20and%20watch%20elegantly%20arranged%20on%20light%20marble%20surface%20with%20soft%20natural%20window%20lighting%20minimalist%20product%20photography%20warm%20cream%20tones%20sophisticated%20editorial%20style&width=400&height=400&seq=cat-img-accessories-10&orientation=squarish',
    description: 'Watches, sunglasses, jewelry and more to elevate any outfit.',
  },
  {
    id: 11,
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20stylish%20leather%20bag%20displayed%20on%20clean%20wooden%20surface%20with%20soft%20natural%20daylight%20minimalist%20fashion%20accessory%20photography%20warm%20neutral%20tones%20elegant%20editorial%20composition%20showcasing%20sophisticated%20design&width=400&height=400&seq=cat-img-bags-11&orientation=squarish',
    description: 'Backpacks, crossbody bags, totes and travel bags for every need.',
  },
  {
    id: 12,
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20premium%20leather%20belt%20displayed%20on%20clean%20light%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20fashion%20accessory%20photography%20warm%20cream%20tones%20sophisticated%20editorial%20product%20showcase&width=400&height=400&seq=cat-img-belts-12&orientation=squarish',
    description: 'Premium belts crafted from genuine leather and durable materials.',
  },
  {
    id: 13,
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20designer%20perfume%20bottle%20on%20clean%20white%20marble%20surface%20with%20soft%20natural%20window%20light%20minimalist%20fragrance%20product%20photography%20warm%20cream%20tones%20sophisticated%20editorial%20composition%20showcasing%20luxury%20scent&width=400&height=400&seq=cat-img-perfumes-13&orientation=squarish',
    description: 'Designer-inspired fragrances with long-lasting and captivating scents.',
  },
  {
    id: 14,
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20miscellaneous%20lifestyle%20fashion%20items%20elegantly%20arranged%20on%20light%20wooden%20surface%20with%20soft%20natural%20lighting%20minimalist%20product%20photography%20warm%20neutral%20tones%20editorial%20aesthetic%20showcasing%20variety%20of%20accessories&width=400&height=400&seq=cat-img-other-14&orientation=squarish',
    description: 'Discover more unique items and hidden gems in our collection.',
  },
];